module.exports = __webpack_public_path__ + "static/use-case-4-content-1-b-82e4014aafa8173a24cc94635a72fadf.png";